import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/pro-solid-svg-icons";

import "./index.scss";

const Agreements = ({ agreements }) => {
  if (!agreements?.length) return null;

  return (
    <div className="kiosk-comm-agreements">
      {agreements.map((item, index) => (
        <div className="kiosk-comm-agreement" key={index}>
          <FontAwesomeIcon icon={faCheckSquare} className="i-green" />
          <span className="kiosk-comm-agreement-name">{item.name}</span>
        </div>
      ))}
    </div>
  );
};

export default Agreements;
